// Volunteer flow for the Game Designer Kit build.
// The build is done by a single volunteer (A) going through 8 steps in order.
// The Design track (Volunteer "Other") routes to /design and is not modelled here.

import { getStepByNo, steps as allSteps } from "@/data/lampContent";

export const VOLUNTEERS = ["A"];
// A single flat phase — kept for compatibility with the phase-aware components.
export const TOTAL_PHASES = 1;
export const PHASE_NUMBERS = [1];

export const VOLUNTEER_STORAGE_KEY = "volunteer-choice";

// Convenience: (0->a, 1->b, …)
export const letterOf = (idx) => String.fromCharCode(97 + idx);

// Volunteer A's ordered flow: every build step, in order, then a `done` sentinel.
function buildFlowA() {
  return [
    ...allSteps.map((s) => ({ type: "step", phase: 1, no: s.no })),
    { type: "done" },
  ];
}

export const volunteerFlows = {
  A: buildFlowA(),
};

export function getFlow(volunteer) {
  return volunteerFlows[volunteer] || null;
}

// Label shown on step badges / progress lists for a step item.
export function stepButtonLabel(item) {
  if (item.type !== "step") return "";
  return item.label ? item.label : String(item.no);
}

// Full "Step X: Title" line for phase-intro lists.
export function stepTitleLine(item) {
  const step = getStepByNo(item.no);
  const label = item.label ? item.label : String(item.no);
  return {
    label,
    title: step ? step.title : "",
  };
}

// The phase currently associated with a flow item (undefined for `done`).
export function phaseOf(item) {
  return item && item.type !== "done" ? item.phase : undefined;
}

// First flow index that belongs to a given phase (used by the phase bar).
export function firstIndexOfPhase(volunteer, phase) {
  const flow = getFlow(volunteer);
  if (!flow) return 0;
  return flow.findIndex((it) => it.phase === phase);
}

export function readSavedVolunteer() {
  try {
    const v = localStorage.getItem(VOLUNTEER_STORAGE_KEY);
    return VOLUNTEERS.includes(v) ? v : null;
  } catch {
    return null;
  }
}

export function saveVolunteer(v) {
  try {
    localStorage.setItem(VOLUNTEER_STORAGE_KEY, v);
  } catch {
    /* ignore */
  }
}

// Count of step items in a volunteer's flow (for the Done page badge).
export function stepCountOf(volunteer) {
  const flow = getFlow(volunteer);
  if (!flow) return 0;
  return flow.filter((it) => it.type === "step").length;
}

// No cross-volunteer collaboration in this build — always empty.
export function collaboratorsFor() {
  return [];
}
